<template>
  <hr class="mb-2 mt-3 w-full" />
</template>
